import { render, staticRenderFns } from "./SimModalEdicion.vue?vue&type=template&id=26a66e98&scoped=true&"
import script from "./SimModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./SimModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./SimModalEdicion.vue?vue&type=style&index=0&id=26a66e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a66e98",
  null
  
)

export default component.exports